import { useState, useEffect } from 'react';
import { WIDGET_DATA } from '../Components/Customer/components/ReviewsMobile';

const useReviewStats = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const store = WIDGET_DATA.store;
        const res = await fetch(
          `https://api.reviews.io/merchant/latest?store=${store}&per_page=1&page=1`
        );
        const data = await res.json();
        const s = data?.stats;
        if (s) {
          setStats({
            average: Number(s.average ?? s.average_rating ?? 0).toFixed(2),
            count: Number(s.count ?? s.total_reviews ?? 0),
          });
        }
      } catch {
        // fail silently — hardcoded fallback will show nothing
      }
    };

    fetchStats();
  }, []);

  return stats;
};

export default useReviewStats;
